module.exports = __webpack_public_path__ + "assets/img/wuliu.f646e49d.png";